export default __webpack_public_path__ + "static/media/m3.46931c27.svg";